import Button from '@components/UI/Button';
import Icon from '@components/UI/Icon';
import Paragraph from '@components/UI/Typography/Paragraph';
import useMods from '@hooks/useMods';
import pdfIcon from '@images/pdf.svg';

import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

const FileUploaderFile = ({ mods={}, file, name, onClick }) => {
    const { className } = useMods(FileUploaderFile, { mods });
    const [imgSrc, setImgSrc] = useState(null);

    useEffect(() => {
        if(file?.type.includes('pdf')) {
            setImgSrc(pdfIcon);
        }

        return () => setImgSrc(null);
    }, [file]);

    return (
        <div
            className={ className }
        >
            { file && (
                <img
                    src={ imgSrc || URL.createObjectURL(file) }
                    className='file-uploader-file-image'
                    alt={ name }
                />
            ) }

            <Paragraph
                tag='span'
                size='sm'
                id='textDropArea'
            >
                { name }
            </Paragraph>

            <Button
                variant='link'
                mix={ { 'file-uploader-file-close': true } }
                onClick={ onClick }
            >
                <Icon
                    name='close'
                    color='red-900'
                    size={ 24 }
                />
            </Button>
        </div>
    );
};

FileUploaderFile.displayName = 'File-Uploader-File';

FileUploaderFile.propTypes = {
    file: PropTypes.object,
    mods: PropTypes.object,
    name: PropTypes.string,
    onClick: PropTypes.func
};

export default FileUploaderFile;
